export abstract class BaseAnalyticsProvider {
	public abstract sendEvent(actionName: string, actionData: unknown): Promise<void>

	public abstract identifyUser(userId: string): Promise<void>

	public abstract resetUser(): Promise<void>
}
